import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const LeaveStatus = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.availabilityLeaveStatus,
      list: REDUCER_KEY.availabilityLeaveStatuses
    }}
    config={config}
    permissions={permissions}
  />
);

LeaveStatus.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default LeaveStatus;
